import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import api from "../lib/api";
import PublicHeader from "../components/PublicHeader";
import PublicFooter from "../components/PublicFooter";

export default function Page() {
  const { slug } = useParams();
  const [page, setPage] = useState(null);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    setPage(null); setNotFound(false);
    api.get(`/pages/${slug}`).then((r) => setPage(r.data)).catch(() => setNotFound(true));
  }, [slug]);

  return (
    <div className="min-h-screen bg-white text-slate-900">
      <PublicHeader />
      <section className="bg-slate-900 py-20" data-testid="page-hero">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <h1 className="font-display text-4xl sm:text-5xl font-black tracking-tight text-white">{page?.hero_title || page?.title || (notFound ? "Page not found" : "Loading…")}</h1>
          {page?.hero_subtitle && <p className="text-lg text-slate-200 mt-4">{page.hero_subtitle}</p>}
        </div>
      </section>
      <section className="py-16 bg-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 space-y-10" data-testid="page-body">
          {notFound && <p className="text-slate-500">The page you're looking for doesn't exist.</p>}
          {(page?.blocks || []).map((b, i) => (
            <div key={i}>
              {b.heading && <h2 className="font-display text-2xl font-bold text-slate-900">{b.heading}</h2>}
              <p className="text-slate-600 mt-3 leading-relaxed whitespace-pre-line">{b.body}</p>
            </div>
          ))}
        </div>
      </section>
      <PublicFooter />
    </div>
  );
}
